export default "__VITE_ASSET__b5dd7406__"